<template>
  <div class="content_box">
    <div class="head_box">
      <div class="avatar">
        <img class="avatar_img" :src="userInfo.avatar" />
      </div>
      <div>
        <div class="userName">用户：{{userInfo.nickName}}</div>
        <div class="userName">{{userInfo.phoneNumber}}</div>
      </div>
    </div>
    <div class="body_box">
      <div class="body_item" @click="queryBindAccount">
        <div style="width: 22px; display: flex">
          <img src="../assets/card.png" class="card_img" />
        </div>
        <span>我的户号</span>
      </div>
      <div class="body_item" @click="toMyAccount">
        <div style="width: 22px; display: flex">
          <img src="../assets/account.png" class="card_img" />
        </div>
        <span>消息订阅</span>
      </div>
      <div class="body_item" @click="updatePwd">
        <div style="width: 22px; display: flex">
          <img src="../assets/pwd.png" class="card_img" style="width: 0.3rem;" />
        </div>
        <span>密码修改</span>
      </div>
      <div class="body_item" @click="changePhoneNumber">
        <div style="width: 22px; display: flex">
          <img src="../assets/phone2.png" class="card_img" style="width: 0.3rem;"/>
        </div>
        <span>更换手机号</span>
      </div>
    </div>
    <div style="padding: 0.5rem 0.24rem">
      <div class="recharge_btn" @click="logout">退出登录</div>
    </div>
  </div>
</template>
<script>
import { setToken, getToken } from "@/libs/util.js";
import { getUserInfo } from "@/api/user.js";
import { Form } from "vant";
import { Notify } from "vant";
export default {
  data() {
    return {
      userInfo: {}
    };
  },
  created() {
    getUserInfo().then(res => {
      if (res.data.status == 200) {
        this.userInfo = res.data.object;
      } else {
        Notify({ type: "danger", message: res.data.msg });
      }
    });
  },
  methods: {
    updatePwd() {
      this.$router.push({
        path: `/tcmr/updatePwd?setPass=${this.userInfo.setPass}`
      });
    },
    changePhoneNumber() {
      this.$router.push({
        path: `/tcmr/updatePhoneNumber`
      });
    },
    queryBindAccount() {
      this.$router.push({
        path: `/tcmr/accountList`
      });
    },
    //退出登录
    logout() {
      setToken("");
      this.$router.push({
        path: `/tcmr/home`
      });
      Notify({ type: "success", message: "退出登录成功!" });
    },
    //我的账户
    toMyAccount() {}
  }
};
</script>
<style scoped>
.recharge_btn {
  color: #fff;
  height: 0.6rem;
  font-size: 0.26rem;
  line-height: 0.6rem;
  margin: 0rem 0.3rem;
  margin-top: 0.3rem;
  background: #50c7a1;
  border-radius: 0.06rem;
}
.body_item {
  display: flex;
  height: 0.8rem;
  padding: 0 0.5rem;
  align-items: center;
  border-bottom: 1px solid #ececec;
}
.body_item span {
  font-size: 0.24rem;
}
.userName {
  color: #fff;
  font-size: 0.24rem;
  padding-left: 0.1rem;
}
.avatar {
  width: 1rem;
  height: 1rem;
  background: #fff;
}
.avatar_img {
  width: 1rem;
  height: 1rem;
}
.head_box {
  display: flex;
  height: 2.5rem;
  align-items: center;
  padding-left: 0.5rem;
  background-repeat: no-repeat;
  background-size: 6.4rem auto;
  background: url("../assets/myTopBG.png");
}
</style>